export class MakePaymentMethodDefaultResponseDTO{
      message !: string

      constructor(data: MakePaymentMethodDefaultResponseDTO){
        Object.assign(this, data);
      }
}